import React, { useState } from "react";
import {
  AppBar,
  Box,
  Typography,
  IconButton,
  Toolbar,
  Avatar,
  Menu,
  MenuItem,
  useTheme,
} from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import useStyles from "../../styles/components/AppHeader";

const BuyerAppHeader = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const userMenuOpen = Boolean(anchorEl);

  const getNameInitials = () => {
    if (!user) return "?";
    const name = user.displayName || user.email || "";
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    if (parts[0]?.length >= 2) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return parts[0]?.[0]?.toUpperCase() || "?";
  };

  const handleLogout = async () => {
    try {
      await logout();
      setAnchorEl(null);
      navigate("/comprador/login", { replace: true });
    } catch (error) {
      console.error("Falha ao fazer logout:", error);
    }
  };

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <Typography variant="h6" noWrap component="div" fontWeight="bold">
            Área do comprador
          </Typography>
        </Box>
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          size="small"
          aria-controls={userMenuOpen ? "buyer-user-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={userMenuOpen ? "true" : undefined}
        >
          {user?.photoURL ? (
            <Avatar
              sx={{ bgcolor: theme.palette.secondary.main, color: theme.palette.text.secondary }}
              alt="foto do perfil"
              src={user.photoURL}
            />
          ) : (
            <Avatar
              sx={{ bgcolor: theme.palette.background.paper, color: theme.palette.text.secondary }}
            >
              {getNameInitials()}
            </Avatar>
          )}
        </IconButton>
        <Menu
          id="buyer-user-menu"
          anchorEl={anchorEl}
          open={userMenuOpen}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem onClick={handleLogout}>Sair</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default BuyerAppHeader;
